import React, { useState } from "react";
import { paymentForInvoices } from "../ApiController/ApiService";
import { useSearchParams } from "react-router-dom";

function InvoiceByClient() {
    const [searchParams] = useSearchParams();

    const shipmentId = searchParams.get("id");
    const email = searchParams.get("email");

    const [loading, setLoading] = useState(false);

    const handlePayNow = async () => {
        try {
            setLoading(true);

            const payload = {
                shipmentId,
                email,
            };

            console.log("Payload:", payload);

            const response = await paymentForInvoices(shipmentId, email);

         
                if (response?.session?.url) {
                    window.location.href = response.session.url;
                } else {
                    console.error("Stripe URL not found");
                }

          
        } catch (err) {
            console.error("Payment error:", err);
            alert("Payment failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-md text-center">

                <h2 className="text-xl font-semibold text-gray-700 mb-6">
                    Invoice Payment
                </h2>

                {/* Info Section */}
                <div className="mb-6 text-left space-y-2">
                    <p>
                        <span className="font-medium">Shipment ID:</span>{" "}
                        {shipmentId || "N/A"}
                    </p>

                    <p>
                        <span className="font-medium">Email:</span>{" "}
                        {email || "N/A"}
                    </p>
                </div>

                <button
                    onClick={handlePayNow}
                    disabled={loading || !shipmentId}
                    className={`
            w-full py-3 rounded-lg text-white font-medium
            transition duration-300
            ${loading
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-green-600 hover:bg-green-700"
                        }
          `}
                >
                    {loading ? "Processing..." : "Pay Now"}
                </button>

            </div>
        </div>
    );
}

export default InvoiceByClient;